export enum RequestParams {
  Settings = 'settings',
  TableConfig = 'tableConfig',
  BindingAccount = 'Account',
  BindingUser = 'User',
  PlannerParams = 'PlannerParams'
}

